import wx from "weixin-js-sdk";
import { is_weixin } from "@assets/js/common";
export const uploadIMG = (obj) => {
  var that = this;
  if (is_weixin()) {
    obj.$http.get(
      "/wechat/oauth2/getJSSDKConfig?url=" +
        encodeURIComponent(location.href.split("#")[0]),
      {},
      (res) => {
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: [
            "checkJsApi",
            "scanQRCode", //微信扫一扫
            "onMenuShareTimeline", // 分享到朋友圈接口
            "onMenuShareAppMessage", //  分享到朋友接口
            // 'getLocation',
            "uploadImage",
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "chooseImage",
            "previewImage",
            "downloadImage",
            "chooseWXPay",
            "getLocalImgData",
          ],
          openTagList: ["wx-open-launch-weapp"],
        });
      }
    );
  }
};
